import { useDeleteFiles } from '#root/queries/media';
 
export const useFileDelete = () => {
  const deleteFiles = useDeleteFiles();

  return {
    deleteImages: deleteFiles.mutateAsync
  };
};